import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import css from './CreativeAsset.css';

// Handle various YouTube URL formats
const YOUTUBE_LINK_PATTERNS = [
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\n?#]+)/,
    /youtube\.com\/v\/([^&\n?#]+)/,
];

// Convert YouTube URLs to embeddable format
const getYouTubeEmbedUrl = url => {
    if (!url) return null;

    // If it already looks like an embed URL, return as-is
    if (url.includes('youtube.com/embed/')) {
        return url;
    }

    for (const pattern of YOUTUBE_LINK_PATTERNS) {
        const match = url.match(pattern);
        if (match) {
            return `https://www.youtube.com/embed/${match[1]}`;
        }
    }

    return null;
};

const YoutubeAsset = React.forwardRef(({ url, onLoad, onError }, ref) => {
    const embedUrl = getYouTubeEmbedUrl(url);

    useEffect(() => {
        if (embedUrl && onLoad) {
            onLoad();
        } else if (!embedUrl && onError) {
            // If we can't create a valid embed URL, call onError
            onError();
        }
    }, [embedUrl, onLoad, onError]);

    if (!embedUrl) return null;

    return (
        <iframe
            ref={ref}
            src={embedUrl}
            title="YouTube video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className={css.youtubeIframe}
            onLoad={onLoad}
            onError={onError}
        />
    );
});

YoutubeAsset.propTypes = {
    url: PropTypes.string,
    onLoad: PropTypes.func,
    onError: PropTypes.func,
};

export default YoutubeAsset;
